import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

const styles = {
  content: {
    maxHeight: '50vh',
    textAlign: 'justify'
  },
  title: {
    fontWeight: 'bold',
  }
}

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const PrivacyPolicy = (props) => (
  <Dialog
  open={props.openDialog}
  onClose={props.changeDialogState}
  TransitionComponent={Transition}
  keepMounted
  aria-labelledby="simple-dialog-title"
  style={styles}
  >
  <DialogTitle disableTypography={true}> <h1>Privacy Policy</h1> </DialogTitle>
  <DialogContent className={props.classes.content}>
    <span className={props.classes.title}>1 INTRODUCTION</span>
    <br />
      <br /> IMAGE Information Systems Europe GmbH is taking the protection of your
      private data seriously and fully complies with the legal regulations based
      on the German Federal Privacy Act (BDSG) as well as the German Broadcast
      Media Act. The currently used privacy requirements will be continuously
      evolved by our internal quality management system (QMS).
      <br />
      <br /> The following policy gives  you an overview about how we guarantee
      this protection and which data will be surveyed for which purpose.
      <br />

      <br />
    <br /> <span className={props.classes.title}>2 AREA OF APPLICATION</span> <br />
      <br /> This privacy policy covers the web application PACS SIZING CALCULATOR
      entirely and exclusively. It begins with the entrance on this websiterespectively
      the start of usage of the application and ends by leaving the site respectively
      by being forwarded to external content, which can be recognized by a different
      second level domain. <br />
    <br />
    <br /> <span className={props.classes.title}>3 SURVEYING AND PROCESSING DATA</span> <br />
      <br />
      Individual-related data is only surveyed on this website as far as
      it is technically necessary. IMAGE Information Systems Europe GmbH surveys
      and stores the following data in its log files that are automatically transmitted
      by your web browser. 
      <br />

        <ul>
          <li> Browser type and version </li>
          <li> Used operating system </li>
          <li> Referrer URL (previously visited website) </li>
          <li> Hostname and/or IP address of the accessing computer </li>
          <li> Date and time of the connection </li> 
        </ul>
        
      <br /> The log file and all its containing information will be deleted by the system 
      itself after 7 days.
      Usually, this information will not be accessed. Under special circumstances
      the system core&apos;s information will be accessed for the purpose of bug
      fixing if otherwise the system would become inoperable. Communication with
      the user does not occur at any time. Access to this information is only
      granted to a maximum of 3 people, which are specially trained and sensitized
      in handling privacy relevant low level information. Merging this kind of
      information with other data sources does not occur at any time. <br />
      <br /> The following information will be stored unencrypted in a database
      by the web application: <br /> <br />

      <ul>  
        <li>Session ID </li>
        <li>Type of imaging centre </li>
        <li>Geographical region </li>
        <li>Archive period in years </li>
        <li>Modalities </li>
        <li>Number of images per study </li>
        <li>Number of studies per day </li>
      </ul>

    <br />
      All data is transmitted unencrypted. The provided information will be used
      for an automatic process that calculates the estimated size of a planned
      PACS project. Except the name and the session ID all pieces of information
      are exclusively used for the mathematical algorithm this web application
      is based on. <br />
    <br />
      The session ID is used to enable the user to retrieve his session including
      all entered data and cannot be used by the processing body to establish
      a connection between the user and the stored data without his assistance.
      The session ID is only used for the purpose of outside identification
      and will be replaced with another internal pseudonomized number after login
      that cannot be found out in a classical way. <br />
    <br />
      Please notice that the calculation&apos;s result will not be stored on our
      servers at any time as it is dynamically created each time you start the
      calculation process.  <br />
      Only your basic input values will be stored for the above mentioned period. <br />
    <br /> 
    <br /> <span className={props.classes.title}>4 USE AND TRANSFER OF DATA TO A THIRD PARTY</span> <br />
        <br />
        The entered base values will only be used to calculate the size of the PACS
        project and will not be transferred to a third party. <br />
        <br />
    <br /> <span className={props.classes.title}>5 COOKIES</span> <br />
        <br /> To protect your privacy and to enhance the level of privacy and security,
        this web application uses only Cookies, which are essential for the application‘s
        opertion. <br />
        <br />
    <br />
    <br /> <span className={props.classes.title}>6 GOOGLE ANALYTICS</span> <br />
        <br /> To protect your privacy and to enhance the level of privacy and security,
        this web application does not use GOOGLE Analytics. <br />
    <br />
    <br /> <span className={props.classes.title}>7 RIGHT TO BE INFORMED/PROCESSING BODY</span> <br />
        <br /> Under constitutional law, which guarantees the informational
        self-determination the user has the permanent and persistent right to get
        information about his individual-related data that is stored by the processing
        body according to § 34 BDSG. <br />
        This request must be answered immediately and free of charge. <br />
        <br /> Contact person for all privacy related requests is the data protection
        officer or any other employee. <br />
        <br /> IMAGE Information Systems Europe GmbH <br /> Chief Information
        Security Officer <br /> Lange Str. 16 <br /> 18055 Rostock <br /> Germany <br />
      <br /> privacy@image-systems.biz <br />
    <br />
  </DialogContent>
  <DialogActions>
    <Button onClick={props.changeDialogState} variant="raised" color="primary">
      Close
    </Button>
  </DialogActions>
  </Dialog >  
);

PrivacyPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool.isRequired,
  changeDialogState: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/PrivacyPolicy.js